import { useRequesterStore } from '../stores/requester'

export async function apiLogin(token: string, userData: any) {
  try {
    const requesterX = useRequesterStore()
    const resp = await requesterX.Post({
      route: `/auth/admin-login`,
      withAuth: false,
      body: {
        token,
        userData,
      },
      extraHeader: {
        isPublic: true,
      },
    })

    return resp
  } catch (e) {
    throw e
  }
}
export async function closeSession() {
  try {
    const requesterX = useRequesterStore()
    await requesterX.Get({
      route: `/auth/close-session`,
      withAuth: true,
    })
    return true
  } catch (e) {
    throw e
  }
}
